<template>
  <div class="sch-page">
    <div class="container py-4">
      <SectionHeader label="الجدول الدراسي" title="الجدول الدراسي" subtitle="مواعيد حصصك الأسبوعية" />

      <!-- Loading -->
      <div v-if="loading" class="sch-list">
        <div v-for="n in 3" :key="n" class="skel-row"></div>
      </div>

      <!-- Empty -->
      <div v-else-if="!days.length" class="sch-empty">
        <i class="pi pi-calendar"></i>
        <p>لا يوجد جدول دراسي محدد لك حالياً.</p>
      </div>

      <!-- Weekly schedule, grouped by day -->
      <div v-else class="sch-list">
        <div v-for="d in days" :key="d.value" class="sch-day-card">
          <div class="sch-day-card__head">
            <span class="sch-day-card__title">{{ d.label }}</span>
          </div>
          <div class="sch-slot" v-for="s in d.slots" :key="s.id">
            <div class="sch-slot__time">
              <i class="pi pi-clock"></i>
              <span dir="ltr">{{ s.start_time }} – {{ s.end_time }}</span>
            </div>
            <div class="sch-slot__subject">{{ s.subject_name || 'حصة' }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionHeader from '@/components/common/SectionHeader.vue';
import { subscriptionService } from '@/services/subscriptionService.js';

const DAY_LABELS = ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'];

export default {
  name: 'MySchedule',
  components: { SectionHeader },
  data() {
    return { schedule: [], loading: true };
  },
  computed: {
    // Groups the flat (already day/time-ordered) list into one card per day
    // that actually has a slot, in weekday order — never a hardcoded Sat–Fri grid.
    days() {
      const byDay = new Map();
      for (const s of this.schedule) {
        if (!byDay.has(s.day_of_week)) byDay.set(s.day_of_week, []);
        byDay.get(s.day_of_week).push(s);
      }
      return [...byDay.keys()].sort((a, b) => a - b).map(value => ({
        value,
        label: DAY_LABELS[value] ?? value,
        slots: byDay.get(value),
      }));
    },
  },
  methods: {
    async load() {
      this.loading = true;
      try { this.schedule = await subscriptionService.mySchedule(); }
      catch { this.schedule = []; }
      finally { this.loading = false; }
    },
  },
  mounted() { this.load(); },
};
</script>

<style scoped>
.sch-page { min-height: 60vh; padding-bottom: 5rem; }
.sch-list { display: grid; gap: 1rem; }
.sch-day-card { background: #fff; border: 1px solid rgba(91,95,239,.1); border-radius: 16px; padding: 1rem 1.2rem; }
.sch-day-card__head { margin-bottom: .7rem; }
.sch-day-card__title { font-size: 1rem; font-weight: 800; color: #111827; }
.sch-slot {
  display: flex; align-items: center; justify-content: space-between; gap: .6rem;
  padding: .6rem 0; border-top: 1px dashed rgba(91,95,239,.12);
}
.sch-slot:first-of-type { border-top: none; }
.sch-slot__time { display: flex; align-items: center; gap: .4rem; font-size: .82rem; color: #5B5FEF; font-weight: 700; }
.sch-slot__subject { font-size: .88rem; color: #374151; font-weight: 600; }
.sch-empty { text-align: center; padding: 3.5rem 1rem; color: #94a3b8; }
.sch-empty .pi { font-size: 2.6rem; display: block; margin-bottom: .8rem; }
.skel-row { height: 90px; border-radius: 16px; background: #e9edf5; position: relative; overflow: hidden; }
.skel-row::after { content: ''; position: absolute; inset: 0; transform: translateX(-100%); background: linear-gradient(90deg, transparent, rgba(255,255,255,.6), transparent); animation: sh 1.3s infinite; }
@keyframes sh { 100% { transform: translateX(100%); } }
</style>
